export const projectEmployeeTaskRegEx =
  /^\/reports\/by-projects\/project\d+\/employee\d+\/start\d{4}-\d{2}-\d{2}\/end\d{4}-\d{2}-\d{2}\/accrual[\w,]+\/tasks.+/;

export const projectEmployeeAllTaskRegEx =
  /^\/reports\/by-projects\/project\d+\/start\d{4}-\d{2}-\d{2}\/end\d{4}-\d{2}-\d{2}\/accrual[\w,]+\/tasks.+/;
